/*** IMPORTS FROM imports-loader ***/
(function() {

define(['plugin.tooltip', 'thd-cart-bindings', 'thd-carousel', 'thd-overlay'], function(toolTip, thdCartBindings, thdCarousel, thdOverlay) {
  return {
    init: function init() {
      window.tntExposedObjects = {
        'plugin.tooltip': toolTip,
        'thd-cart-bindings': thdCartBindings,
        'thd-carousel': thdCarousel,
        'thd-overlay': thdOverlay,
      };
    }
  }
});

}.call(window));